export const gameSession = {
  state: {
    session_uuid: null,
    team_uuid: null,
    code: null,
  },
  reducers: {
    reset: (_, payload) => {
      return payload;
    },
  },
};

export const alert = {
  state: {
    visible: false,
    type: "alert",
    title: "",
    message: "",
    onClose: () => {},
  },
  reducers: {
    show: (_, payload) => {
      return { visible: true, ...payload };
    },
    hide: () => {
      return { visible: false };
    },
  },
};
